module.exports = __webpack_public_path__ + "static/media/piper-settings-business.a2dcb914.svg";